import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layout } from '../../../components/Layout';
import { Box, Button, FormContainer } from '@utex/ui-kit';
import { CommissionNote } from '../../../components/CommissionNote';
import { CardFields } from '../../../components/CardFields';
import { Instrument } from '../../../hooks/mapInstruments';
import { AmountInput } from '../../../components/AmountInput';
import { useFormProps } from './hooks';
import { FormError } from '../../../components/FormError';
import { Warning } from '../Warning';

export interface FormValues {
  amount: number;
  cardNumber: string;
  cardHolderName: string;
}

export const Content: React.FC<Instrument> = (props) => {
  const { t } = useTranslation('toTinkoffCard');
  const { validate, validateTips, onSubmit } = useFormProps(props);

  const { currency, commission } = props;

  return (
    <FormContainer<FormValues>
      onSubmit={onSubmit}
      validate={validate}
      validateTips={validateTips}
      render={({ values: { amount }, handleSubmit, submitError, submitting }) => (
        <Layout.Form onSubmit={handleSubmit} noValidate>
          <Layout.FormContent>
            <Box display="flex" flexDirection="column">
              <AmountInput currency={currency} />
              <Warning />
              <CardFields currency={props.currency} />
            </Box>
          </Layout.FormContent>
          <FormError>{submitError}</FormError>
          <Layout.FormFooter>
            <Button view="alert" type="submit" isLoading={submitting}>
              {t('Continue')}
            </Button>
            <CommissionNote
              commission={commission}
              amount={{ value: amount || 0, currency }}
              caption={t('From the account will be charged')}
              isReverse={false}
            />
          </Layout.FormFooter>
        </Layout.Form>
      )}
    />
  );
};
